/* eslint-disable prefer-destructuring,func-names,react/prop-types,prefer-arrow-callback */
import React from 'react';
import { Spin, Upload, Input, Icon } from 'antd';
import styled from 'styled-components';

import Button from '../../views/StyledButton';
import Table from '../../views/StyledTable';
import ContentWidthClamper from '../../views/ContentWidthClamper';
import ButtonList from '../../views/ButtonList';
import { FormRow } from '../../views/Form';
import PageFrame from '../../views/PageFrame';
import HeadlineBreadcrumbList from '../../views/HeadlineBreadcrumbList';
import SelectableHeader from '../../views/SelectableHeader';
import SearchFrame from '../../views/SearchFrame';
import NameSearchFrame from '../../views/NameSearchFrame';
import DeleteCheckedButton from '../../views/DeleteCheckedButton';
import { RED_ERROR } from '../../views/styleConstants';

const ErrWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  width: 100%;
`;

const Err = styled.div`
  flex: 1;
  color: ${RED_ERROR}
  text-align: Right;
`;

export default (bottle) => {
  // eslint-disable-next-line prefer-arrow-callback
  bottle.factory(
    'SpottingGroupDrilldownView',
    function () {
      return ({
        termsCheckList, data, columns, uploadProps,
        rowSelection, name, deleteChecked, searchTerm, setSearchTerm,
        scrollY, save, currentTermEditedName, setEditingTermName, revert,
        deleteGroup, goBack, goHome, loading, isLoading, tableProps,
        headline, canDelete, canSave, isNew, hasBadWords,
      }) => (
        <div>
          <PageFrame noBottom>
            <ContentWidthClamper>
              <HeadlineBreadcrumbList>
                {[
                    { onClick: goHome, text: 'Home' },
                    { onClick: goBack, text: 'Spotting Groups' },
                    headline,
                  ]}
              </HeadlineBreadcrumbList>
            </ContentWidthClamper>
          </PageFrame> {
            loading ? (
              <PageFrame notop>
                <ContentWidthClamper><Spin size="large" /></ContentWidthClamper>
              </PageFrame>
            ) : (
              <PageFrame noTop noBottom>
                <NameSearchFrame>
                  <FormRow label="Name" labelSpan={5} bottomMargin={0} height={35}>
                    <Input
                      value={currentTermEditedName}
                      onChange={event => setEditingTermName(event.target.value)}
                    />
                  </FormRow>
                  <SearchFrame value={searchTerm} onChange={setSearchTerm} />
                </NameSearchFrame>

                <SelectableHeader dataHidden={!termsCheckList.length}>
                  <DeleteCheckedButton
                    onClick={deleteChecked}
                  >Delete Checked
                  </DeleteCheckedButton>
                </SelectableHeader>
                <Table
                  id="spotting-group-terms"
                  columns={columns}
                  hightlightSelectable={termsCheckList.length}
                  rowSelection={rowSelection}
                  pagination={false}
                  dataSource={data}
                  loading={isLoading}
                  rowKey="id"
                  scroll={({ y: scrollY })}
                  {...tableProps}
                  footer={() => (
                    <div id="spotting-group-terms-footer">
                      <ButtonList line={false} expandFirst>
                        <ErrWrapper>
                          <Upload {...uploadProps}>
                            <Button>
                              <Icon type="upload" /> Import CSV
                            </Button>
                          </Upload>
                          {hasBadWords && <Err>CANNOT SAVE: You have illegal characters in your terms</Err>}
                        </ErrWrapper>
                        {!isNew && <Button onClick={revert}>Revert</Button>}
                        {!isNew && (
                        <Button
                          type="danger"
                          disabled={!canDelete}
                          onClick={deleteGroup}
                        >Delete
                        </Button>
          )}
                        <Button
                          type="primary"
                          onClick={save}
                          disabled={!canSave}
                        >Save
                        </Button>
                      </ButtonList>
                    </div>)}
                />
              </PageFrame>
            )
          }
        </div>
      );
    },
  );
};
